import Layout from '../../layout/index'

const attentionRouter = {
  path: '/attention',
  component: Layout,
  redirect: '/attention/index',
  children: [
    {
      path: 'index',
      name: 'attentionBasicInfo',
      component: () => import('../../views/attention/index')
    },
    {
      path: 'reserve',
      name: 'attentionReserve',
      component: () => import('../../views/attention/reserve')
    }
  ]
}
export default attentionRouter
